import type { FC } from 'react';
import { SxProps } from '@mui/system';
import { Box, Stack, Typography } from '@mui/material';

interface TenantSwitchProps {
  sx?: SxProps;
}

export const TenantSwitch: FC<TenantSwitchProps> = (props) => {
  return (
    <>
      <Stack alignItems="center"
direction="row"
spacing={2}
{...props}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography color="inherit"
variant="h6">
            캐파 프렌즈
          </Typography>
          {/* <Typography color="neutral.400" variant="body2">
            메뉴
          </Typography> */}
        </Box>
        {/* <IconButton onClick={popover.handleOpen} ref={popover.anchorRef}>
          <SvgIcon sx={{ fontSize: 16 }}>
            <ChevronDownIcon />
          </SvgIcon>
        </IconButton> */}
      </Stack>
      {/* <TenantPopover
        anchorEl={popover.anchorRef.current}
        onChange={popover.handleClose}
        onClose={popover.handleClose}
        open={popover.open}
        tenants={tenants}
      /> */}
    </>
  );
};
